module.exports = __webpack_public_path__ + "img/art-postcard.aeee76d5.png";